import React, { useState } from 'react';
import { Button } from '../components/ui/button';
import { Card } from '../components/ui/card';
import { CheckCircle2, Shield, Zap, Globe, Download, MonitorSmartphone, Play, Rocket, Orbit, Satellite, Star, Sparkles } from 'lucide-react';

const Landing = () => {
  const [email, setEmail] = useState('');

  const handlePurchase = () => {
    //https://buy.stripe.com/test_5kQdR82V428m43O3HKfIs00
    window.location.href = 'https://buy.stripe.com/test_5kQdR82V428m43O3HKfIs00';
  };

  const handleDownload = (platform) => {
    // Mock download action
    alert(`Download para ${platform} será disponibilizado em breve!`);
  };

  return (
    <div className="min-h-screen bg-slate-950 text-white relative overflow-hidden">
      {/* Animated space background */}
      <div className="fixed inset-0 z-0">
        <div className="absolute inset-0 bg-[url('https://images.pexels.com/photos/956981/milky-way-starry-sky-night-sky-star-956981.jpeg')] bg-cover bg-center opacity-20"></div>
        <div className="absolute inset-0 bg-gradient-to-b from-slate-950/90 via-slate-950/70 to-slate-950"></div>
        {/* Floating stars */}
        <div className="absolute top-20 left-10 w-2 h-2 bg-cyan-400 rounded-full animate-pulse"></div>
        <div className="absolute top-40 right-20 w-1 h-1 bg-purple-400 rounded-full animate-pulse delay-100"></div>
        <div className="absolute top-60 left-1/4 w-1.5 h-1.5 bg-emerald-400 rounded-full animate-pulse delay-200"></div>
        <div className="absolute bottom-40 right-1/3 w-2 h-2 bg-blue-400 rounded-full animate-pulse delay-300"></div>
      </div>

      {/* Content */}
      <div className="relative z-10">
        {/* Header */}
        <header className="fixed top-0 left-0 right-0 z-50 backdrop-blur-xl bg-slate-950/70 border-b border-slate-800/50">
          <div className="container mx-auto px-6 py-4 flex items-center justify-between">
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-purple-500 via-blue-500 to-cyan-500 flex items-center justify-center">
                <Rocket className="w-5 h-5 text-white" />
              </div>
              <span className="text-xl font-semibold">tôaqui<span className="text-purple-400">.digital</span></span>
            </div>
            <nav className="hidden md:flex items-center gap-8">
              <a href="#como-funciona" className="text-slate-300 hover:text-purple-400 transition-colors">Como funciona</a>
              <a href="#beneficios" className="text-slate-300 hover:text-purple-400 transition-colors">Benefícios</a>
              <a href="#seguranca" className="text-slate-300 hover:text-purple-400 transition-colors">Segurança</a>
              <Button onClick={handlePurchase} className="bg-gradient-to-r from-purple-500 via-blue-500 to-cyan-500 hover:from-purple-600 hover:via-blue-600 hover:to-cyan-600 text-white font-semibold">
                <Rocket className="w-4 h-4 mr-2" />
                Comprar por R$270
              </Button>
            </nav>
          </div>
        </header>

      {/* Hero Section */}
      <section className="pt-32 pb-20 px-6">
        <div className="container mx-auto max-w-6xl">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <div className="inline-flex items-center gap-2 px-4 py-2 bg-slate-800/50 rounded-full border border-purple-500/30 mb-6">
                <Sparkles className="w-4 h-4 text-purple-400" />
                <span className="text-purple-400 text-sm font-medium">Pagamento único • Sem mensalidade</span>
              </div>
              <h1 className="text-5xl md:text-6xl font-bold mb-6 leading-tight">
                Nunca mais fique <span className="text-transparent bg-clip-text bg-gradient-to-r from-purple-400 via-blue-400 to-cyan-400">Ausente</span> sem perceber.
              </h1>
              <p className="text-xl text-slate-300 mb-8 leading-relaxed">
                <b>Tô Aqui</b>  mantém você disponível no Teams e Slack enquanto você "trabalha" normalmente.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 mb-8">
                <Button
                  onClick={handlePurchase}
                  size="lg"
                  className="bg-gradient-to-r from-purple-500 via-blue-500 to-cyan-500 hover:from-purple-600 hover:via-blue-600 hover:to-cyan-600 text-white font-semibold text-lg px-8 py-6 shadow-lg shadow-purple-500/20 transition-all hover:shadow-purple-500/40"
                >
                  <Rocket className="w-5 h-5 mr-2" />
                  Comprar por R$270
                </Button>
                <Button
                  variant="outline"
                  size="lg"
                  className="border-slate-700 hover:border-purple-500 hover:bg-slate-800 text-lg px-8 py-6"
                  onClick={() => document.getElementById('como-funciona').scrollIntoView({ behavior: 'smooth' })}
                >
                  <Play className="w-5 h-5 mr-2" />
                  Ver como funciona
                </Button>
              </div>
              <div className="flex items-center gap-6 text-sm text-slate-400">
                <div className="flex items-center gap-2">
                  <CheckCircle2 className="w-5 h-5 text-purple-400" />
                  <span>Windows</span>
                </div>
                <div className="flex items-center gap-2">
                  <CheckCircle2 className="w-5 h-5 text-purple-400" />
                  <span>macOS</span>
                </div>
                <div className="flex items-center gap-2">
                  <CheckCircle2 className="w-5 h-5 text-purple-400" />
                  <span>Linux</span>
                </div>
              </div>
            </div>
            <div className="relative">
              {/* Astronaut floating */}
              <div className="absolute -top-10 -right-10 w-32 h-32 opacity-30">
                <img
                  src="https://images.unsplash.com/photo-1712600582303-1f4aedade635"
                  alt="Astronaut"
                  className="w-full h-full object-contain animate-float"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-r from-purple-500/20 via-blue-500/20 to-cyan-500/20 blur-3xl"></div>
              <img
                src="https://images.pexels.com/photos/2156/sky-earth-space-working.jpg"
                alt="Astronaut working in space"
                className="relative rounded-2xl shadow-2xl border border-slate-800/50 ring-2 ring-purple-500/20"
              />
              {/* Floating orbits decoration */}
              <div className="absolute -bottom-6 -left-6 w-24 h-24">
                <Orbit className="w-full h-full text-purple-400/30 animate-spin-slow" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* How It Works */}
      <section id="como-funciona" className="py-20 px-6 bg-slate-900/30 backdrop-blur-sm">
        <div className="container mx-auto max-w-5xl">
          <div className="text-center mb-16">
            <Satellite className="w-12 h-12 text-purple-400 mx-auto mb-4" />
            <h2 className="text-4xl font-bold mb-4">Como funciona</h2>
            <p className="text-xl text-slate-400">Simples e direto. Três passos para nunca ficar ausente.</p>
          </div>
          <div className="grid md:grid-cols-3 gap-8">
            <div className="relative group">
              <div className="absolute -top-4 -left-4 w-12 h-12 rounded-full bg-gradient-to-br from-purple-500 via-blue-500 to-cyan-500 flex items-center justify-center text-white font-bold text-xl shadow-lg shadow-purple-500/50">1</div>
              <Card className="bg-slate-800/50 border-slate-700 p-6 pt-8 hover:bg-slate-800/70 hover:border-purple-500/50 transition-all group-hover:scale-105 duration-300">
                <Download className="w-12 h-12 text-purple-400 mb-4" />
                <h3 className="text-xl font-semibold mb-3 text-white">Ative o Tô Aqui</h3>
                <p className="text-slate-300">Baixe e instale em segundos. Compatível com Windows, macOS e Linux.</p>
              </Card>
            </div>
            <div className="relative group">
              <div className="absolute -top-4 -left-4 w-12 h-12 rounded-full bg-gradient-to-br from-purple-500 via-blue-500 to-cyan-500 flex items-center justify-center text-white font-bold text-xl shadow-lg shadow-blue-500/50">2</div>
              <Card className="bg-slate-800/50 border-slate-700 p-6 pt-8 hover:bg-slate-800/70 hover:border-blue-500/50 transition-all group-hover:scale-105 duration-300">
                <Satellite className="w-12 h-12 text-blue-400 mb-4" />
                <h3 className="text-xl font-semibold mb-3 text-white">Roda silenciosamente na bandeja</h3>
                <p className="text-slate-300">O app fica discreto na bandeja do sistema. Sem janelas, sem interrupções.</p>
              </Card>
            </div>
            <div className="relative group">
              <div className="absolute -top-4 -left-4 w-12 h-12 rounded-full bg-gradient-to-br from-purple-500 via-blue-500 to-cyan-500 flex items-center justify-center text-white font-bold text-xl shadow-lg shadow-cyan-500/50">3</div>
              <Card className="bg-slate-800/50 border-slate-700 p-6 pt-8 hover:bg-slate-800/70 hover:border-cyan-500/50 transition-all group-hover:scale-105 duration-300">
                <Rocket className="w-12 h-12 text-cyan-400 mb-4" />
                <h3 className="text-xl font-semibold mb-3 text-white">Seu status permanece online</h3>
                <p className="text-slate-300">Automaticamente. Sem cliques, sem configuração. Apenas funciona.</p>
              </Card>
            </div>
          </div>
        </div>
      </section>

      {/* Benefits */}
      <section id="beneficios" className="py-20 px-6 relative">
        {/* Nebula background */}
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1709409903008-fbc1ce9b7dfa')] bg-cover bg-center"></div>
          <div className="absolute inset-0 bg-gradient-to-b from-slate-950 via-transparent to-slate-950"></div>
        </div>
        <div className="container mx-auto max-w-6xl relative z-10">
          <div className="text-center mb-16">
            <Star className="w-12 h-12 text-cyan-400 mx-auto mb-4 animate-pulse" />
            <h2 className="text-4xl font-bold mb-4">Por que usar Tô Aqui?</h2>
            <p className="text-xl text-slate-400">Benefícios claros para trabalho remoto</p>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            <Card className="bg-slate-800/30 backdrop-blur-sm border-slate-700 p-6 hover:bg-slate-800/50 hover:border-purple-500/50 transition-all hover:scale-105 duration-300">
              <CheckCircle2 className="w-10 h-10 text-purple-400 mb-4" />
              <h3 className="text-lg font-semibold mb-2 text-white">Evita status "Ausente"</h3>
              <p className="text-slate-300">Nunca mais pareça indisponível em reuniões ou trabalho remoto.</p>
            </Card>
            <Card className="bg-slate-800/30 backdrop-blur-sm border-slate-700 p-6 hover:bg-slate-800/50 hover:border-blue-500/50 transition-all hover:scale-105 duration-300">
              <Zap className="w-10 h-10 text-blue-400 mb-4" />
              <h3 className="text-lg font-semibold mb-2 text-white">Não clica nem digita</h3>
              <p className="text-slate-300">Funciona de forma inteligente sem simular atividade fake.</p>
            </Card>
            <Card className="bg-slate-800/30 backdrop-blur-sm border-slate-700 p-6 hover:bg-slate-800/50 hover:border-cyan-500/50 transition-all hover:scale-105 duration-300">
              <Satellite className="w-10 h-10 text-cyan-400 mb-4" />
              <h3 className="text-lg font-semibold mb-2 text-white">Funciona minimizado</h3>
              <p className="text-slate-300">Roda na bandeja do sistema. Feche a janela e continue trabalhando.</p>
            </Card>
            <Card className="bg-slate-800/30 backdrop-blur-sm border-slate-700 p-6 hover:bg-slate-800/50 hover:border-purple-500/50 transition-all hover:scale-105 duration-300">
              <Globe className="w-10 h-10 text-purple-400 mb-4" />
              <h3 className="text-lg font-semibold mb-2 text-white">Não depende de internet</h3>
              <p className="text-slate-300">Funciona totalmente local no seu computador. Offline e rápido.</p>
            </Card>
            <Card className="bg-slate-800/30 backdrop-blur-sm border-slate-700 p-6 hover:bg-slate-800/50 hover:border-blue-500/50 transition-all hover:scale-105 duration-300">
              <Rocket className="w-10 h-10 text-blue-400 mb-4" />
              <h3 className="text-lg font-semibold mb-2 text-white">Leve e rápido</h3>
              <p className="text-slate-300">Consumo mínimo de recursos. Não trava nem atrasa seu PC.</p>
            </Card>
            <Card className="bg-slate-800/30 backdrop-blur-sm border-slate-700 p-6 hover:bg-slate-800/50 hover:border-cyan-500/50 transition-all hover:scale-105 duration-300">
              <Sparkles className="w-10 h-10 text-cyan-400 mb-4" />
              <h3 className="text-lg font-semibold mb-2 text-white">Compra única</h3>
              <p className="text-slate-300">Pagou, é seu. Sem assinaturas, sem renovações, sem surpresas.</p>
            </Card>
          </div>
        </div>
      </section>

      {/* Why R$10 */}
      <section className="py-20 px-6 bg-slate-900/30 backdrop-blur-sm">
        <div className="container mx-auto max-w-4xl">
          <div className="text-center">
            <div className="inline-flex items-center gap-3 mb-6">
              <Sparkles className="w-10 h-10 text-purple-400" />
              <h2 className="text-4xl font-bold">Por que custa R$270?</h2>
              <Sparkles className="w-10 h-10 text-cyan-400" />
            </div>
            <p className="text-xl text-slate-300 mb-6 leading-relaxed">
              Tô Aqui é um utilitário simples, focado em resolver um único problema muito bem.
            </p>
            <p className="text-xl text-slate-300 mb-8 leading-relaxed">
              Sem assinaturas, sem planos, sem armadilhas.
            </p>
            <div className="inline-block px-8 py-4 bg-gradient-to-r from-purple-900/30 via-blue-900/30 to-cyan-900/30 rounded-2xl border border-purple-500/30 backdrop-blur-sm">
              <p className="text-2xl font-semibold text-transparent bg-clip-text bg-gradient-to-r from-purple-400 via-blue-400 to-cyan-400">
                Um pequeno investimento para manter sua produtividade e presença online PARA SEMPRE.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Security */}
      <section id="seguranca" className="py-20 px-6">
        <div className="container mx-auto max-w-5xl">
          <div className="text-center mb-16">
            <div className="relative inline-block">
              <Shield className="w-16 h-16 text-purple-400 mx-auto mb-6 relative z-10" />
              <div className="absolute inset-0 bg-purple-500/30 blur-xl"></div>
            </div>
            <h2 className="text-4xl font-bold mb-4">Segurança & Privacidade</h2>
            <p className="text-xl text-slate-400">Sua privacidade é nossa prioridade</p>
          </div>
          <div className="grid md:grid-cols-3 gap-8">
            <Card className="bg-slate-800/30 backdrop-blur-sm border-slate-700 p-6 text-center hover:bg-slate-800/50 hover:border-purple-500/50 transition-all hover:scale-105 duration-300">
              <div className="relative inline-block mb-4">
                <Shield className="w-12 h-12 text-purple-400 mx-auto relative z-10" />
                <div className="absolute inset-0 bg-purple-500/20 blur-lg"></div>
              </div>
              <h3 className="text-lg font-semibold mb-3 text-white">100% Local</h3>
              <p className="text-slate-300">Nenhum dado é enviado para servidores externos. Tudo funciona no seu computador.</p>
            </Card>
            <Card className="bg-slate-800/30 backdrop-blur-sm border-slate-700 p-6 text-center hover:bg-slate-800/50 hover:border-blue-500/50 transition-all hover:scale-105 duration-300">
              <CheckCircle2 className="w-12 h-12 text-blue-400 mx-auto mb-4" />
              <h3 className="text-lg font-semibold mb-3 text-white">Sem acesso a mensagens</h3>
              <p className="text-slate-300">Não acessa, não lê, não vê suas conversas ou conteúdo em qualquer app.</p>
            </Card>
            <Card className="bg-slate-800/30 backdrop-blur-sm border-slate-700 p-6 text-center hover:bg-slate-800/50 hover:border-cyan-500/50 transition-all hover:scale-105 duration-300">
              <Globe className="w-12 h-12 text-cyan-400 mx-auto mb-4" />
              <h3 className="text-lg font-semibold mb-3 text-white">Sem login ou contas</h3>
              <p className="text-slate-300">Não pedimos email, senha ou dados pessoais. Instale e use.</p>
            </Card>
          </div>
        </div>
      </section>

      {/* Platforms */}
      <section className="py-20 px-6 bg-slate-900/30 backdrop-blur-sm">
        <div className="container mx-auto max-w-4xl text-center">
          <h2 className="text-4xl font-bold mb-12">Compatível com os principais sistemas operacionais</h2>
          <div className="flex flex-wrap justify-center gap-12 items-center">
            <div className="flex flex-col items-center gap-4 group">
              <div className="w-20 h-20 rounded-2xl bg-slate-800/50 border border-slate-700 group-hover:border-purple-500 flex items-center justify-center transition-all group-hover:scale-110 duration-300">
                <MonitorSmartphone className="w-10 h-10 text-purple-400" />
              </div>
              <span className="text-lg font-semibold">Windows</span>
            </div>
            <div className="flex flex-col items-center gap-4 group">
              <div className="w-20 h-20 rounded-2xl bg-slate-800/50 border border-slate-700 group-hover:border-blue-500 flex items-center justify-center transition-all group-hover:scale-110 duration-300">
                <MonitorSmartphone className="w-10 h-10 text-blue-400" />
              </div>
              <span className="text-lg font-semibold">macOS</span>
            </div>
            <div className="flex flex-col items-center gap-4 group">
              <div className="w-20 h-20 rounded-2xl bg-slate-800/50 border border-slate-700 group-hover:border-cyan-500 flex items-center justify-center transition-all group-hover:scale-110 duration-300">
                <MonitorSmartphone className="w-10 h-10 text-cyan-400" />
              </div>
              <span className="text-lg font-semibold">Linux</span>
            </div>
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <section className="py-20 px-6">
        <div className="container mx-auto max-w-4xl">
          <Card className="relative overflow-hidden bg-gradient-to-br from-slate-800/50 to-slate-900/50 border-slate-700 p-12 text-center">
            {/* Decorative elements */}
            <div className="absolute top-0 right-0 w-64 h-64 bg-purple-500/10 rounded-full blur-3xl"></div>
            <div className="absolute bottom-0 left-0 w-64 h-64 bg-cyan-500/10 rounded-full blur-3xl"></div>

            <div className="relative z-10">
              <div className="flex items-center justify-center gap-4 mb-6">
                <Rocket className="w-12 h-12 text-purple-400" />
                <h2 className="text-4xl md:text-5xl font-bold text-white">Pague uma vez. Use sempre.</h2>
                <Star className="w-12 h-12 text-cyan-400" />
              </div>
              <p className="text-xl text-slate-300 mb-8">Sem mensalidade. Sem login. Sem complicação.</p>
              <Button
                onClick={handlePurchase}
                size="lg"
                className="bg-gradient-to-r from-purple-500 via-blue-500 to-cyan-500 hover:from-purple-600 hover:via-blue-600 hover:to-cyan-600 text-white font-semibold text-xl px-12 py-8 shadow-lg shadow-purple-500/20 transition-all hover:shadow-purple-500/40 hover:scale-105 duration-300"
              >
                <Rocket className="w-6 h-6 mr-2" />
                Adquirir Software por R$270
              </Button>
            </div>
          </Card>
        </div>
      </section>

      {/* Footer */}
      <footer className="py-12 px-6 border-t border-slate-800">
        <div className="container mx-auto max-w-6xl">
          <div className="flex flex-col md:flex-row justify-between items-center gap-6">
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-purple-500 via-blue-500 to-cyan-500 flex items-center justify-center">
                <Rocket className="w-5 h-5 text-white" />
              </div>
              <span className="text-lg font-semibold">tôaqui<span className="text-purple-400">.digital</span></span>
            </div>
            <nav className="flex gap-8">
              <a href="#privacidade" className="text-slate-400 hover:text-purple-400 transition-colors">Privacidade</a>
              <a href="#termos" className="text-slate-400 hover:text-purple-400 transition-colors">Termos</a>
              <a href="#suporte" className="text-slate-400 hover:text-purple-400 transition-colors">Suporte</a>
            </nav>
          </div>
          <div className="mt-8 text-center text-slate-500 text-sm">
            © {new Date().getFullYear()} Tô Aqui • Pagamento único de R$270
          </div>
        </div>
      </footer>
      </div>
    </div>
  );
};

export default Landing;
